/* eslint-disable no-param-reassign */

import { BoxProps } from '@mui/material/Box';
import { ReactNode, useState } from 'react';
import { errorHandler } from '../utils/errors';
import { IconName } from './display/Icon';

export function useAsyncHandler({
  disabled = false,
  errorMessage = '',
  handler,
}: {
  disabled?: boolean;
  errorMessage?: string;
  handler?: (...args: any[]) => any;
}) {
  const [isProcessing, setIsProcessing] = useState(false);

  return [onHandle as any, isProcessing];

  function onHandle(e: any) {
    if (disabled || typeof handler !== 'function') {
      return;
    }

    const result = handler(e) as any;

    if (result?.then && result?.catch && result?.finally) {
      setIsProcessing(true);
      result
        .catch(errorHandler(errorMessage))
        .finally(() => setIsProcessing(false));
    }
  }
}

export type SxProps = BoxProps['sx'];

export type Size = 'large' | 'medium' | 'small' | number;

export type ItemWithLabel<T = any> = {
  disabled?: boolean;
  icon?: IconName;
  label: ReactNode;
  value: T;
};
